import React, { useState, createRef } from "react";
import UploadContainer from "./UploadContainer";
import Cat from "../icons/cat.svg";

const UploadModal = ({
  closeModalAfterUpload,
  errors,
  setErrors,
  setLocationMode,
  setNotificationId,
  setPostId,
  setPosts,
  setSelected,
}) => {
  const [imageOrientation, setImageOrientation] = useState("");
  const [previewImage, setPreviewImage] = useState("");
  const [previewMessage, setPreviewMessage] = useState(true);
  const imageRef = createRef();

  const imageSize = (height, width) => {
    if (height > width) {
      setImageOrientation("portrait");
    } else {
      setImageOrientation("landscape");
    }
  };

  return (
    <div className="auth-modal">
      <div className="preview-panel">
        <div className="mobile-header">
          <button className="close-btn" onClick={closeModalAfterUpload}>
            X
          </button>
          <h2>Share a photo</h2>
        </div>
        <div className="static-container">
          <div className="cat-img-container">
            <img
              ref={imageRef}
              onLoad={() => {
                imageSize(
                  imageRef.current.naturalHeight,
                  imageRef.current.naturalWidth
                );
              }}
              src={previewImage !== "" ? previewImage : Cat}
              alt="user-icon"
              className={
                imageOrientation === "portrait"
                  ? "portrait-img"
                  : "landscape-img"
              }
            />
          </div>
        </div>
        <div className="preview-container">
          {previewImage !== "" && previewMessage ? (
            <p className="preview">
              Image preview
              <br />
              Click upload to save!
            </p>
          ) : null}
        </div>
      </div>
      <div>
        <UploadContainer
          closeModalAfterUpload={closeModalAfterUpload}
          errors={errors}
          setErrors={setErrors}
          setLocationMode={setLocationMode}
          setNotificationId={setNotificationId}
          setPostId={setPostId}
          setPosts={setPosts}
          setPreviewImage={setPreviewImage}
          setPreviewMessage={setPreviewMessage}
          setSelected={setSelected}
        />
      </div>
    </div>
  );
};

export default UploadModal;
